<template>
  <main :class="$options.name">
    <Head
      title="Nice Bike"
      description="We are a family owned small bicycle shop that is dedicated to bringing you the absolute best in cycling. We are Nice Bike."
      keywords="nice bike"
      image="https://ridenicebike.com/img/social.jpg"
      url="https://ridenicebike.com"
    />
    <Loader v-if="loading"/>
    <Hero v-if="!errored && !loading && page.hero.fields" :img="page.hero.fields.file.url">
      <RichText :value="page.heroText"/>
    </Hero>
    <article v-if="!errored && !loading">
      <section v-if="builds.length" id="builds" :class="$options.name + '__builds'">
        <header class="innerWrap">
          <h2>Latest builds</h2>
          <p>
            <router-link to="/builds" aria-label="See all bike builds">
              See all
              <Icon name="arrow-right" :size="14"/>
            </router-link>
          </p>
        </header>
        <section :class="$options.name + '__builds--wrapper'">
          <BuildTile
            v-for="build in builds"
            :key="build.fields.title"
            :img="build.fields.hero.fields.file.url"
            :path="build.fields.title"
            :title="build.fields.title"
          />
        </section>
      </section>
      <section v-if="services.length" id="services" :class="$options.name + '__services'">
        <header class="innerWrap">
          <h2>Services</h2>
          <p>
            <router-link to="/contact" aria-label="Contact us to say hello">
              Get in touch
              <Icon name="arrow-right" :size="14"/>
            </router-link>
          </p>
        </header>
        <Service
          v-for="service in services"
          :key="service.sys.id"
          :description="service.fields.description"
          :img="service.fields.image.fields.file.url"
          :subtitle="service.fields.subtitle"
          :title="service.fields.title"
        />
      </section>
    </article>
  </main>
</template>
<script>
import BuildTile from "@/components/BuildTile";
import Hero from "@/components/Hero";
import Icon from "@/components/Icon";
import Service from "@/components/Service";
import Loader from "@/components/Loader";
import RichText from "@/components/RichText";
export default {
  name: "Home",
  components: { BuildTile, Hero, Icon, Loader, RichText, Service },
  computed: {
    builds() {
      let builds = this.$store.state.builds;
      return builds.slice(0,4);
    }
  },
  data() {
    return {
      apiSpace: this.$store.state.apiSpace,
      apiToken: this.$store.state.apiToken,
      errored: false,
      loading: true,
      page: [],
      services: []
    };
  },
  methods: {
    getHome() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        space: this.apiSpace,
        accessToken: this.apiToken
      });
      client
        .getEntry("014yEPkG75EQ6IHqGMYXrh")
        .then(entry => {
          this.page = entry.fields;
        })
        .catch(error => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getServices() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        space: this.apiSpace,
        accessToken: this.apiToken
      });
      client
        .getEntries({
          content_type: "service",
          order: "fields.title"
        })
        .then(entries => {
          this.services = entries.items;
        })
        .catch(error => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    }
  },
  mounted() {
    this.getHome();
    this.getServices();
  }
};
</script>
<style lang="scss">
.Home {
  article {
    > * + * {
      margin-top: rem(32);
    }
    section > header {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      a {
        align-items: center;
        display: inline-flex;
        .Icon {
          margin-left: rem(8);
        }
      }
    }
    h2 {
      color: var(--base-mid);
      margin-right: rem(32);
    }
  }
  &__builds--wrapper {
    align-items: start;
    display: grid;
    grid-gap: rem(16);
    grid-template-columns: repeat(auto-fit, minmax(rem(320), 1fr));
    justify-items: center;
    margin: rem(16) 0;
    @include breakpoint(l) {
      grid-template-columns: repeat(auto-fit, minmax(rem(480), 1fr));
    }
    @include breakpoint(xxl) {
      grid-template-columns: repeat(auto-fit, minmax(rem(560), 1fr));
    }
  }
}
</style>